import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import DigitizeImg from "../../images/location_new/fold5/img06.webp";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Link } from "gatsby";

function Digitize(props) {
  return (
    <div className="digitize_sec p-100" style={{ backgroundColor: "#040404" }}>
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>
              A Trusted Miami Software Development Company For Your Next Project
            </h2>
            <p>
              We pride ourselves on being the premier choice for software
              development Miami. With a proven track record of delivering
              high-quality solutions to clients across various industries, we
              are dedicated to helping you bring your next project to life. Our
              team of experienced software developers in Miami is committed to
              understanding your unique needs and crafting customized software
              solutions that exceed your expectations. Whether you need a mobile
              app, web application, or enterprise software, we have the
              expertise and skills to deliver results that drive your business
              forward.
            </p>
            <p>
              Miami's unique blend of cultures, industries, and markets calls
              for a tailored approach to software development. Our commitment is
              not just about providing solutions; it's about helping businesses
              embrace digital transformation. We leverage the latest
              technologies and industry insights to craft software that
              streamlines operations, enhances customer experiences, and drives
              substantial growth.
            </p>
            <p>
              As one of the best Miami software development companies, we use
              the latest technologies and industry insights to craft software
              that streamlines operations, boosts customer experiences, and
              drives substantial growth.
            </p>
            <Link
              style={{
                backgroundColor: "#fff",
                color: "#040404",
                border: "1px solid #040404",
              }}
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              rel="noopener"
            >
              Book A Consultation Now!
            </Link>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="digitize_img">
            <LazyLoadImage
              src={DigitizeImg}
              effect="blur"
              alt="Image"
              className="img-fluid"
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Digitize;
